var jsProduct = (function($, D_, window) {

  var PROD = {};
  PROD = {
    init: function() {
      var self = this;

      self.changed();
      self.qty();
      self.imgTasks();
      self.addCart();
      self.tabs();

    },
    changed: function() {
      $('.ppib-selector .swatch :radio').change(function() {
        var optIdx = $(this).closest('.swatch').attr('data-option-index');
        var optVal = $(this).val();
        console.log(optIdx)
        console.log(optVal)
        $(this).closest('form').find('.single-option-selector').eq(optIdx).val(optVal).trigger('change');
      });
    },
    total: function() {
      var regx = /[\d]{1,3}(\,[\d]{3})?(\.[\d]{2})?/g;
      var norm = document.querySelector('.ppib-price-normal');
      var regxMatch = norm.textContent.match(regx)[0];
      if (regxMatch) {
        var round = regxMatch.replace(/[\.|\,]/g, '');
        var q = parseInt($('#qty').val(), 10);
        var tot = round * q;
        var price = Shopify.formatMoney(tot, "<span class='money'>${{amount}}</span>");
        price = price.match(regx);
        var newRegx = new RegExp(regxMatch, "g");
        var totEl = $('.ppib-price-normal').html().replace(newRegx, price);
        $('#ppibPriceTotal').html(totEl);

        Currency.convertAll('USD', $('#currencies').val(), 'span.money', 'money_format');
      }
    },
    qty: function() {
      var self = this;
      var btn = document.querySelectorAll('.ppib-qty button');
      var btns = Array.prototype.slice.call(btn);
      var value = document.querySelector('.ppib-qty-value');
      var $value = $('.ppib-qty-value');

      btns.forEach(function(el, idx) {
        el.addEventListener('click', function(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var $val = $(".ppib-qty-value")
          var qVal = $val.val();
          var n = 1;
          var c = ev.target.getAttribute('class');
          if ( c === 'ppib-qty-incr' ) {
            n = parseInt(qVal, 10) + 1;
          } else if ( qVal > 1 ) {
            n = parseInt(qVal, 10) - 1;
          }
          $val.val(n);
          self.total();
        });
      });

      // change total if input value changed
      value.addEventListener('change', function(ev) {
        var gelVal = $(ev.target).val();
        if (gelVal > 0) {
          self.total();
        } else {
          $(ev.target).val(1);
          self.total();
        }
      });
    },
    imgTasks: function() {
      var t = document.querySelectorAll('.ppi-img-thumbs > li > img')
      var tmbs = Array.prototype.slice.call(t);
      var toucheDev = Modernizr.touchevents;

      var $feat = $('#ppiImgFeat');
      var feat = document.getElementById('ppiImgFeat');
      $feat.waitForImages(function(){
        feat.setAttribute('data-loaded', '1');
      })

      // magnify
      if(D_.settings.magnify && !jsGlobal.touchEvents) {
        if(!toucheDev) {
          $("#ppgImg").magnify({speed:0});
        }
      }

      tmbs.forEach(function(el, idx) {
        el.addEventListener('click', function(ev) {
          var selected = el.parentNode.getAttribute('data-selected');
          var tar = document.getElementById('ppgImg')
          var full = document.getElementById("ppiImgFullsize")
          var src = el.parentNode.getAttribute('data-src');
          if (selected === '1') {
            return;
          }
          $('.ppi-img-thumbs > li').attr('data-selected', '0')
          ev.target.parentNode.setAttribute('data-selected', '1')
          tar.setAttribute('src', src)
          tar.setAttribute('data-magnify-src', src)
          full.setAttribute('href', src)

          var $feat = $('#ppiImgFeat');
          var feat = document.getElementById('ppiImgFeat');
          feat.setAttribute('data-thumb', '0');
          $feat.waitForImages(function(){
            feat.setAttribute('data-thumb', '1');
          })
          if(D_.settings.magnify && !jsGlobal.touchEvents) {
            if(!toucheDev) {
              $("#ppgImg").magnify({speed:0});
            }
          }
        })
      });
    },
    addCart: function() {
      var addBtn = document.getElementById('productSubmit');
      var err = document.getElementById('productSubmitErr')
      addBtn.addEventListener('click', function(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var et = ev.target;
        var vari = $('.ppib-selector select[name=id]').val();
        if (!vari) {
          vari = $('.ppib-selector input[name=id]').val();
        }
        var qty = $('#qty').val();
        if (!qty) {
          qty = 1;
        }
        $.ajax({
          type: 'post',
          url: '/cart/add.js',
          data: { quantity: qty, id: vari },
          dataType: 'json',
          beforeSend: function() {
            et.setAttribute('disabled', 'true');
            console.log('wait propa add cart...')
          },
          success: function() {
            jsGlobal.updateCart();
            et.removeAttribute('disabled')
            console.log('propa add cart success...');
          },
          error: function(xhr, txt) {
            if(xhr.status === 422) {
              var mes = $.parseJSON(xhr.responseText).description;
              var p = document.createElement('p')
              p.setAttribute('class', 'feedback-warning')
              p.textContent = mes;
              err.appendChild(p);
              setTimeout(function(){
                if (err.hasChildNodes()) {
                  err.removeChild(err.firstChild);
                }
              }, 5000)
            }
            ev.target.removeAttribute('disabled');
            console.log('error propa add cart...')
          }
        })

      });
    },
    tabs: function() {
      var scope = document.getElementById('descriptionTabs');
      var tabs = Array.prototype.slice.call(scope.querySelectorAll('.ppi-tab a'));
      var content = Array.prototype.slice.call(scope.querySelectorAll('.ppi-tab-content'));
      var current = 0;

      tabs.forEach(function(el, idx) {
        el.addEventListener('click', function(ev) {
          ev.preventDefault();

          if( current >= 0 ) {
            tabs[ current ].parentNode.setAttribute('data-open', '0')
            content[ current ].setAttribute('data-open', '0')
          }
          if (idx != undefined) {
            current = idx
          }
          tabs[ current ].parentNode.setAttribute('data-open', '1')
          content[ current ].setAttribute('data-open', '1')
        })
      })

    }
  }

  // option selectors for product page
  Shopify.optionsMap = {};
  Shopify.updateOptionsInSelector = function(selectorIndex) {
    var sos = $('.ppib-selector .single-option-selector');
    switch (selectorIndex) {
      case 0:
        var key = 'root';
        var selector = sos.eq(0);
        break;
      case 1:
        var key = sos.eq(0).val();
        var selector = sos.eq(1);
        break;
      case 2:
        var key = sos.eq(0).val();  
        key += ' / ' + sos.eq(1).val();
        var selector = sos.eq(2);
    }
    
    var initialValue = selector.val();
    selector.empty();    
    var availableOptions = Shopify.optionsMap[key];
    for (var i=0; i<availableOptions.length; i++) {
      var option = availableOptions[i];
      var newOption = $('<option></option>').val(option).html(option);
      selector.append(newOption);
    }
    $('.ppib-selector .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
      var t = $(this);
      if ($.inArray(t.attr('data-value'), availableOptions) !== -1) {
        t.removeClass('soldout').show().find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
      }
      else {
        t.addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled','disabled');
      }
    });
    if ($.inArray(initialValue, availableOptions) !== -1) {
      selector.val(initialValue);
    }
    selector.trigger('change');  
    
  };
  Shopify.linkOptionSelectors = function(product) {
    // Building our mapping object.
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
        Shopify.optionsMap['root'].push(variant.option1);
        Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    // When there is an update in the first dropdown.
    $(".ppib-selector .single-option-selector:eq(0)").change(function() {
      Shopify.updateOptionsInSelector(1);
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
      return true;
    });
    // When there is an update in the second dropdown.
    $(".ppib-selector .single-option-selector:eq(1)").change(function() {
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
      return true;
    });
    
  };

  var selectCallbackProd = function(variant, selector) {

    if (variant) {

      // change prices
      var $prices = $('#ppibPrices');
      var $normal = $prices.find('.ppib-price-normal');
      var $compare = $prices.find('.ppib-price-compare');
      var off = document.getElementById('ppibOff')

      $normal.html(Shopify.formatMoney(variant.price, "<span class=money>${{amount}}</span>"));
      if ( variant.compare_at_price > variant.price ) {
        $compare.html(Shopify.formatMoney(variant.compare_at_price, "<span class=money>${{amount}}</span>"));
        $normal.html(Shopify.formatMoney(variant.price, "<span class=money>${{amount}}</span>"));
        var offNum = (variant.compare_at_price - variant.price) / (variant.compare_at_price /  100);
        off.textContent = Math.floor(offNum) + "% " + D_.translate.off;
        off.setAttribute('class', 'ppib-price-off badge-info')
      } else {
        $compare.html("");
        if(off) {
          off.textContent = "";
          off.setAttribute('class', 'ppib-price-off')
        }
      }

      // total price
      PROD.total()

      // checked first variant
      var form = $('#' + selector.domIdPrefix).closest('form');
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
        if (radioButton.size()) {
          radioButton.get(0).checked = true;
        }
      }

      // inventory
      var invenInfo = document.querySelector('.ppib-invent');
      if(invenInfo) {
        if (variant.available ) {
          if (variant.inventory_management !== null) {
            if (variant.inventory_policy === 'continue') {
              invenInfo.textContent = variant.inventory_quantity +" "+ D_.translate.in_stock +" ("+ D_.translate.allow_purchase + ")";
            } else {
              invenInfo.textContent = variant.inventory_quantity + " " + D_.translate.in_stock;
            }
            invenInfo.setAttribute('class', 'ppib-invent badge-warning');
          } else {
            invenInfo.setAttribute('class', 'ppib-invent');
            invenInfo.textContent = "";
          }
        } else {
          invenInfo.setAttribute('class', 'ppib-invent badge-warning');
          invenInfo.textContent = D_.translate.out_stock;
        }
      }

      // switch imgs
      if (variant.featured_image) {
        var oriImg = $("#ppgImg");
        var newImg = variant.featured_image;
        var elem = oriImg[0];
        var toucheDev = Modernizr.touchevents;
        var full = document.getElementById("ppiImgFullsize")

        // magnify
        Shopify.Image.switchImage(newImg, elem, function(a,b,c) {
          c.setAttribute('src', a)
          c.setAttribute('data-magnify-src', a)
          full.setAttribute('href', a)
          var th = document.querySelectorAll('.ppi-img-thumbs > li > img');
          var thumb = Array.prototype.slice.call(th);
          thumb.forEach(function(el, idx) {
            el.parentNode.setAttribute('data-selected', '0')
            $('.ppi-img-thumbs > li[data-pos='+ (b.position) +']').attr('data-selected', '1');
          });
          var $feat = $('#ppiImgFeat');
          var feat = document.getElementById('ppiImgFeat');
          feat.setAttribute('data-thumb', '0');
          $feat.waitForImages(function(){
            feat.setAttribute('data-thumb', '1');
          })
          if(D_.settings.magnify && !jsGlobal.touchEvents) {
            if(!toucheDev) {
              $("#ppgImg").magnify({speed:0});
            }
          }
        })
      }
    }
  }

  if (D_.product.available && D_.product.variants.length > 1) {
    new Shopify.OptionSelectors('productSelect', {
      product: D_.product,
      onVariantSelected: selectCallbackProd
    });
  }

  if (D_.product.available && D_.product.options.length > 1) {
    Shopify.optionsMap = {};
    Shopify.linkOptionSelectors(D_.product);
  }


  if (D_.settings.related) {
    var $scope = $('#ppiRelated');
    var templ = document.getElementById('quickView');
    new emQuick($scope, templ);
  }

  var $wishScope = $('#productPage');
  new emWish($wishScope)
  
  PROD.init();

})(jQuery, D_, window);